import {Usage} from '../common/UsageSchema';
import {EnhanceMessageResponse} from './EnhanceMessageResponseSchema';

export type EnhanceMessageUseCaseResult = {
  result: EnhanceMessageResponse;
  usage: Usage;
};
